import { Button } from '../components/ui/button';

interface ExportStaleHintProps {
  onRetry: () => void;
}

/** Shown when a background refetch failed while older data is still on screen. */
export function ExportStaleHint({ onRetry }: ExportStaleHintProps) {
  return (
    <span className="flex items-center gap-1 text-caption-regular text-muted-foreground">
      Out of date ·
      <Button type="button" size="sm" variant="link" className="h-auto p-0" onClick={onRetry}>
        Retry
      </Button>
    </span>
  );
}
